import { useEffect, useRef } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';

import * as log from '@/lib/monitoring/logger';

export function PwaUpdateToast() {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(swUrl) {
      log.info('Service worker registered', { swUrl });
    },
    onRegisterError(err) {
      const errorInstance = err instanceof Error ? err : new Error(String(err));
      log.error('Service worker registration failed', errorInstance);
    },
  });

  const pendingUpdateRef = useRef(false);

  useEffect(() => {
    if (needRefresh) {
      log.info('New app version detected, will activate on next navigation');
      pendingUpdateRef.current = true;
    }
  }, [needRefresh]);

  useEffect(() => {
    const applyUpdate = () => {
      if (!pendingUpdateRef.current) return;
      pendingUpdateRef.current = false;
      log.info('Applying deferred service worker update on navigation');
      void updateServiceWorker(true);
    };

    const originalPushState = history.pushState.bind(history);
    const originalReplaceState = history.replaceState.bind(history);

    history.pushState = function patchedPushState(...args) {
      originalPushState(...args);
      applyUpdate();
    };

    history.replaceState = function patchedReplaceState(...args) {
      originalReplaceState(...args);
      applyUpdate();
    };

    window.addEventListener('popstate', applyUpdate);

    return () => {
      history.pushState = originalPushState;
      history.replaceState = originalReplaceState;
      window.removeEventListener('popstate', applyUpdate);
    };
  }, [updateServiceWorker]);

  return null;
}
